export default __webpack_public_path__ + "static/media/resize-fit.617751f5.svg";